import type { PageTranslations } from './pages';

export const pagesEn: PageTranslations = {
  commonExt: {
    clearFilters: 'Clear filters', viewDetails: 'View details', refresh: 'Refresh',
    copyId: 'Copy ID', editData: 'Edit data', active: 'Active', inactive: 'Inactive',
    suspended: 'Suspended', name: 'Name', email: 'Email', phone: 'Phone',
    status: 'Status', type: 'Type', updateSuccess: 'Updated successfully',
    updateError: 'Update failed', refreshSuccess: 'Data refreshed', close: 'Close',
    add: 'Add', create: 'Create', print: 'Print', exportLabel: 'Export',
    saveChanges: 'Save changes', testConnection: 'Test connection', upload: 'Upload',
    required: 'Required', notSpecified: 'Not specified', pending: 'Pending',
    yes: 'Yes', no: 'No', deleteConfirm: 'Confirm delete',
    cannotUndo: 'This action cannot be undone', copy: 'Copy',
  },
  dashboard: { welcomeMessage: 'Welcome, {name}' },
  drivers: {
    pageTitle: 'Drivers', pageSubtitle: 'Manage delivery agents', addDriverButton: 'Add driver',
    tableHeaderName: 'Name', tableHeaderPhone: 'Phone', tableHeaderPaymentType: 'Payment type',
    paymentTypeCommission: 'Commission', paymentTypeSalary: 'Salary',
    tableHeaderCommissionRate: 'Commission rate', tableHeaderCreatedDate: 'Created date',
    viewDetailsTooltip: 'View details', emptyStateTitle: 'No drivers',
    emptyStateDescription: 'No drivers match the search criteria',
    driverIdCopied: 'Driver ID copied', driverNotFound: 'Driver not found',
    driverNotFoundDescription: 'The requested driver could not be found',
    backToListButton: 'Back to list', statusActive: 'Active', statusInactive: 'Inactive',
    copyIdButton: 'Copy ID', currentShipmentsLabel: 'Current shipments',
    shipmentUnitLabel: 'shipments', availableLabel: 'Available', usedCapacityLabel: 'Used capacity',
    cubicMeterUnit: 'm³', usedWeightLabel: 'Used weight', kilogramUnit: 'kg',
    tabOverview: 'Overview', tabZones: 'Zones', tabRoutes: 'Routes',
    tabShipments: 'Shipments', tabLocation: 'Location', tabHistory: 'History', tabFinancial: 'Financial',
    editDataMenuItem: 'Edit data', disableDriverMenuItem: 'Disable driver',
    enableDriverMenuItem: 'Enable driver', assignShipmentMenuItem: 'Assign shipment',
    shipmentsListTitle: 'Shipments list',
    shipmentsListDescription: 'View all shipments assigned to this driver',
    viewShipmentsButton: 'View shipments', trackLocationTitle: 'Track location',
    trackLocationDescription: 'View driver current location on map',
    activityHistoryTitle: 'Activity history',
    activityHistoryDescription: 'View log of all activities and changes',
    errorLoadingDriverData: 'Failed to load driver data',
    delegateLabel: 'Agent:', latitudeLabel: 'Latitude:', longitudeLabel: 'Longitude:',
    lastUpdateLabel: 'Last update:', trackingPageTitle: 'Agent tracking',
    connectedStatus: 'Connected', disconnectedStatus: 'Disconnected',
    activeDriversLabel: 'Active agents:', noActiveDrivers: 'No active agents currently',
    sinceLabel: 'since', activeDriverStat: 'active agent',
    secondsUnit: 'seconds', minuteUnit: 'minutes', hourUnit: 'hours',
  },
  shipments: {
    pageTitle: 'Shipments', pageSubtitle: 'Manage and track shipments', addNew: 'Add new shipment',
    trackingNumber: 'Tracking number', status: 'Status', address: 'Address', recipient: 'Recipient',
    serviceType: 'Service type', value: 'Value', date: 'Date', viewDetails: 'View details',
    emptyTitle: 'No shipments',
    emptyDescription: 'No shipments match the search criteria',
    clearFilters: 'Clear filters', pagination: 'Page {page} of {totalPages}',
    previous: 'Previous', next: 'Next',
  },
  shipmentDetails: {
    back: 'Back', copy: 'Copy', print: 'Print', retryDelivery: 'Retry delivery',
    assignDriver: 'Assign driver', deliveredBadge: 'Delivered', driverSettled: 'Driver settled',
    tenantSettled: 'Tenant settled', codCollection: 'COD collection', pending: 'Pending',
    carrier: 'Carrier', fromCity: 'From city', toCity: 'To city',
    piecesCount: 'Pieces count', createdDate: 'Created date',
    expectedDeliveryDate: 'Expected delivery date', actualDeliveryDate: 'Actual delivery date',
    serviceType: 'Service type', paymentType: 'Payment type', paymentStatus: 'Payment status',
    codAmount: 'COD amount', shipmentValue: 'Shipment value',
    platformFee: 'Platform fee', deliveryFees: 'Delivery fees',
    tenantPayout: 'Tenant payout', total: 'Total', shipmentInfo: 'Shipment info',
    customer: 'Customer', sender: 'Sender', warehouseLocation: 'Warehouse location',
    senderAddress: 'Sender address', recipientAddress: 'Recipient address',
    items: 'Items ({count})', itemName: 'Name', itemQuantity: 'Quantity', itemSku: 'SKU',
    trips: 'Trips ({count})', loading: 'Loading...', noTrips: 'No trips recorded',
    tripSequence: '#', tripType: 'Trip type', tripRoute: 'Route', tripDriver: 'Driver',
    manifest: 'Manifest', attempt: 'Attempt {number}', unassigned: 'Unassigned',
    viewTrip: 'View trip', descriptionTab: 'Description', historyTab: 'History',
    notificationsTab: 'Notifications', timeline: 'Shipment timeline', noHistory: 'No history available',
    noNotifications: 'No notifications for this shipment', notificationsCount: 'Notifications ({count})',
    notificationType: 'Type', notificationChannels: 'Channels', notificationRecipient: 'Recipient',
    notificationTitle: 'Title', channelInApp: 'In-app', channelWhatsapp: 'WhatsApp',
    channelEmail: 'Email', channelSms: 'SMS',
    recipientRoleTenant: 'Tenant', recipientRoleCarrier: 'Carrier',
    recipientRoleDriver: 'Driver', recipientRoleAdmin: 'Admin',
    recipientRoleFinal: 'Final recipient', assignDriverTitle: 'Assign driver',
    noDriversAvailable: 'No drivers available', currentShipments: 'Current shipments:',
    coverageAreas: 'Coverage areas:', retryDialogTitle: 'Retry delivery',
    retryWarning: 'A new delivery trip will be created for retry',
    retryScheduledDate: 'New attempt date', retryNotes: 'Notes',
    retryNotesPlaceholder: 'Optional notes...', cancel: 'Cancel',
    scheduling: 'Scheduling...', scheduleRetry: 'Schedule retry',
    trackingCopied: 'Tracking number copied', failedLoadingDrivers: 'Failed to load drivers',
    failedLoadingNotifications: 'Failed to load notifications',
    failedLoadingHistory: 'Failed to load timeline',
    driverAssignedSuccess: 'Driver assigned successfully', failedAssignDriver: 'Failed to assign driver',
    retryScheduledSuccess: 'New delivery attempt scheduled',
    outForPickup: 'Out for pickup', collectedFromSender: 'Collected from sender',
    inTransit: 'In transit', outForDelivery: 'Out for delivery', delivered: 'Delivered',
    deliveryFailed: 'Delivery failed', returning: 'Returning', returned: 'Returned',
    pendingStatus: 'Pending', totalTrips: 'Total:',
  },
  createShipment: {
    pageTitle: 'Create new shipment', pageSubtitle: 'Fill the data to create a shipment',
    shipmentSection: 'Shipment', customer: 'Customer', selectCustomer: 'Select customer...',
    search: 'Search...', required: 'Required', selectCarrier: 'Select carrier',
    serviceType: 'Service type', selectServiceType: 'Select service type...',
    warehouse: 'Warehouse', loading: 'Loading...', selectWarehouse: 'Select warehouse...',
    selectCustomerFirst: 'Select customer first', default: 'Default',
    products: 'Products', addProduct: 'Add product', productName: 'Product',
    sku: 'SKU', quantity: 'Quantity',
    noProducts: 'No products — click "Add product"',
    productNamePlaceholder: 'Product name', notes: 'Notes',
    notesPlaceholder: 'Additional notes for the shipment...',
    recipientSection: 'Recipient', name: 'Name', recipientName: 'Recipient name',
    country: 'Country', countryPlaceholder: 'Country...', phone: 'Phone number',
    district: 'District', districtPlaceholder: 'District...',
    city: 'City', cityPlaceholder: 'City...', neighborhood: 'Neighborhood',
    neighborhoodPlaceholder: 'Neighborhood...', detailedAddress: 'Detailed address',
    streetPlaceholder: 'Street, building number...', recipientNotes: 'Notes for recipient',
    carrierSection: 'Carrier', noCarriers: 'No contracted carriers',
    addCarrier: 'Add carrier', shipViaCarrierAccount: 'Ship via your carrier account',
    carrierAutomatic: 'Carrier is selected automatically',
    paymentSection: 'Payment', shipmentValue: 'Shipment value', amountPlaceholder: '0.00',
    deliveryFee: 'Delivery fee', automatic: 'Automatic', total: 'Total',
    currencySymbol: 'SAR', paymentMethod: 'Payment method', paymentCash: 'Cash',
    paymentBankTransfer: 'Bank transfer', paymentOnline: 'Online',
    paymentStatus: 'Payment status', paymentPending: 'Pending',
    paymentPaid: 'Paid', paymentPartial: 'Partial',
    submitButton: 'Create shipment', confirmTitle: 'Confirm shipment creation',
    senderSection: 'Sender', warehouseLabel: 'Warehouse',
    recipientConfirm: 'Recipient', shipmentConfirm: 'Shipment',
    carrierConfirm: 'Carrier', carrierLabel: 'Carrier', paymentConfirm: 'Payment',
    shipmentValueConfirm: 'Shipment value', riyalCurrency: 'SAR',
    deliveryFeeConfirm: 'Delivery fee', totalAmount: 'Total amount',
    paymentMethodConfirm: 'Payment method', electronicPayment: 'Electronic payment',
    confirmCreate: 'Confirm and create shipment', editData: 'Edit data',
    submitting: 'Creating...', fillAllFields: 'Please fill all required fields',
    successMessage: 'Shipment created successfully', errorMessage: 'Failed to create shipment',
    itemNamePlaceholder: 'Product name',
    invalidShipmentValue: 'Shipment value must be greater than zero',
    recipientNameRequired: 'Recipient name is required', phoneRequired: 'Phone number is required',
    invalidPhone: 'Phone number is not valid for the selected country',
    addressRequired: 'Address is required', cityRequired: 'City is required',
    districtRequired: 'District is required', neighborhoodRequired: 'Neighborhood is required',
    itemsCount: 'Items count', serviceTypeConfirm: 'Service type',
    noRouteForLane: 'No pricing for this lane',
    selectLocationForPrices: 'Select destination and service type to see shipping prices',
    completeRequiredFields: 'Complete all required fields to enable the create button',
    noRouteCarrierError: 'The selected carrier does not serve this lane',
    paymentModeLabel: 'Who pays what?',
    paymentModeRecipientPaysAll: 'Recipient pays everything (goods + delivery)',
    paymentModeRecipientPaysFee: 'Recipient pays delivery only (goods prepaid)',
    paymentModeSenderPaysAll: 'Sender pays delivery (recipient pays nothing)',
  },
  settings: {
    pageTitle: 'System settings', pageDescription: 'Manage system settings and configuration',
    tabGeneral: 'General', tabNotifications: 'Notifications', tabSecurity: 'Security',
    tabAppearance: 'Appearance', tabIntegration: 'Integration', tabDatabase: 'Database',
    generalTitle: 'General settings', companyNameLabel: 'Company name',
    companyNamePlaceholder: 'Your company name', emailLabel: 'Email',
    phoneLabel: 'Phone number', phonePlaceholder: '05xxxxxxxx',
    timezoneLabel: 'Timezone', addressLabel: 'Address',
    addressPlaceholder: 'Full company address', maintenanceModeLabel: 'Maintenance mode',
    maintenanceModeDescription: 'Enable system maintenance mode',
    allowRegistrationLabel: 'Allow registration',
    allowRegistrationDescription: 'Allow new users to register',
    saveChangesButton: 'Save changes',
    emailNotificationsTitle: 'Email notifications',
    newShipmentLabel: 'New shipment',
    newShipmentDescription: 'Send email when a new shipment is created',
    shipmentStatusLabel: 'Shipment status update',
    shipmentStatusDescription: 'Send email when shipment status changes',
    lateShipmentLabel: 'Late shipment', lateShipmentDescription: 'Alert when a shipment is late',
    dailyReportsLabel: 'Daily reports',
    dailyReportsDescription: 'Send a daily statistics report',
    smsNotificationsTitle: 'SMS notifications',
    deliveryConfirmationLabel: 'Pickup confirmation',
    deliveryConfirmationDescription: 'Send SMS to customer on pickup',
    completionConfirmationLabel: 'Delivery confirmation',
    completionConfirmationDescription: 'Send SMS on delivery completion',
    verificationCodeLabel: 'Verification code',
    verificationCodeDescription: 'Send verification codes via SMS',
    securityTitle: 'Security settings', twoFactorLabel: 'Two-factor authentication',
    twoFactorDescription: 'Enable 2FA for all users',
    strongPasswordLabel: 'Strong password',
    strongPasswordDescription: 'Force users to use strong passwords',
    sessionTimeoutLabel: 'Session timeout (minutes)',
    sessionTimeoutDescription: 'Auto-logout after inactivity period',
    loginAttemptsLabel: 'Login attempts',
    loginAttemptsDescription: 'Failed attempts before account lockout',
    activityLoggingLabel: 'Activity logging',
    activityLoggingDescription: 'Keep a log of all user activities',
    newLoginAlertLabel: 'New login alert',
    newLoginAlertDescription: 'Send notification on new device login',
    apiKeysTitle: 'API keys', primaryApiKeyLabel: 'Primary API key',
    refreshButton: 'Refresh', webhookSecretLabel: 'Webhook secret',
    appearanceTitle: 'Appearance', themeLabel: 'Theme',
    themeLight: 'Light', themeDark: 'Dark', themeAuto: 'Auto',
    languageLabel: 'Language', languageArabic: 'Arabic', languageEnglish: 'English',
    primaryColorLabel: 'Primary color', companyLogoLabel: 'Company logo',
    uploadButton: 'Upload', collapsedSidebarLabel: 'Collapsed sidebar',
    collapsedSidebarDescription: 'Start with sidebar collapsed',
    webhooksTitle: 'Webhooks', webhookUrlLabel: 'Webhook URL',
    webhookUrlPlaceholder: 'https://your-domain.com/webhook',
    webhookUrlDescription: 'Notifications will be sent to this URL',
    enableWebhooksLabel: 'Enable webhooks',
    enableWebhooksDescription: 'Send notifications for important events',
    emailServiceTitle: 'Email service',
    smtpHostLabel: 'SMTP host', smtpHostPlaceholder: 'smtp.gmail.com',
    smtpPortLabel: 'Port', smtpPortPlaceholder: '587',
    smtpEncryptionLabel: 'Encryption', encryptionNone: 'None',
    encryptionTls: 'TLS', encryptionSsl: 'SSL',
    usernameLabel: 'Username', usernamePlaceholder: 'your-email@gmail.com',
    passwordLabel: 'Password', testConnectionButton: 'Test connection',
    smsServiceTitle: 'SMS service', smsProviderLabel: 'Provider',
    providerTwilio: 'Twilio', providerVonage: 'Vonage', providerCustom: 'Custom',
    apiKeyLabel: 'API key', senderNameLabel: 'Sender name',
    backupTitle: 'Backup', autoBackupLabel: 'Auto backup',
    autoBackupDescription: 'Create daily backups',
    backupTimeLabel: 'Backup time', backupRetentionLabel: 'Retention (days)',
    createBackupButton: 'Create backup now', restoreBackupButton: 'Restore from backup',
    dangerZoneTitle: 'Danger zone', deleteOldDataLabel: 'Delete old data',
    deleteOldDataDescription: 'Delete completed shipments older than:',
    deleteNever: 'Never delete', delete6Months: '6 months',
    delete1Year: '1 year', delete2Years: '2 years',
    resetSystemButton: 'Reset system',
    resetSystemWarning: '⚠️ Warning: This action will delete all data and cannot be undone',
    saveSuccessTitle: 'Saved', saveSuccessDescription: 'Settings saved successfully',
  },
  carrierCities: {
    pageTitle: 'Delivery cities',
    pageDescription: 'Define cities and zones covered by carrier',
    stateColumnHeader: 'State', availableCitiesColumnHeader: 'Available cities',
    selectedCitiesColumnHeader: 'Selected cities', editCitiesTooltip: 'Edit cities',
    emptyStateTitle: 'No states', emptyStateDescription: 'No state data in the system',
  },
  coverage: {
    pageTitle: 'Delivery Coverage',
    pageDescription: 'Select cities covered by this carrier',
    countryColumn: 'Country', districtColumn: 'District', citiesColumn: 'Cities',
    saveBtn: 'Save Coverage', selectCountry: 'Select a country', selectDistrict: 'Select a district',
    saved: 'Coverage saved', emptyCountries: 'No countries available',
    selectAll: 'Select all', deselectAll: 'Deselect all',
  },
  deliveryZones: {
    pageTitle: 'Delivery zones', pageDescription: 'Manage delivery zones and their areas',
    codeColumnHeader: 'Code', nameColumnHeader: 'Name', cityColumnHeader: 'City',
    descriptionColumnHeader: 'Description', statusColumnHeader: 'Status',
    statusActive: 'Active', statusInactive: 'Inactive',
    viewAreasTooltip: 'View areas', editTooltip: 'Edit', deleteTooltip: 'Delete',
    addZoneButton: 'Add new zone', emptyStateTitle: 'No zones',
    emptyStateDescription: 'No delivery zones added yet',
    deleteConfirmTitle: 'Confirm delete',
    deleteConfirmDescription: 'Are you sure you want to delete zone "{name}"? This action cannot be undone.',
    cancelButton: 'Cancel', deleteSuccessTitle: 'Deleted',
    deleteSuccessDescription: 'Delivery zone deleted successfully',
    errorTitle: 'Error', deleteErrorDescription: 'Failed to delete delivery zone',
  },
  deliveryZoneDetails: {
    pageTitle: 'Delivery zones', pageDescription: 'View and manage areas of zone {name}',
    notFoundMessage: 'Zone not found',
    removeSuccessTitle: 'Removed', removeSuccessDescription: 'Area removed from zone successfully',
    addSuccessTitle: 'Added', addSuccessDescription: 'Area added to zone successfully',
    errorTitle: 'Error', removeErrorDescription: 'Failed to remove area',
    addErrorDescription: 'Failed to add area',
  },
  routes: {
    listTitle: 'Delivery routes', listSubtitle: 'Manage delivery routes',
    addNewRoute: 'Add new route', code: 'Code', routeName: 'Route name',
    zone: 'From → To', distanceTime: 'Distance / Time', status: 'Status',
    km: 'km', minutes: 'min', active: 'Active', inactive: 'Inactive',
    viewDetails: 'View details', edit: 'Edit', delete: 'Delete',
    noRoutes: 'No routes', noRoutesDesc: 'No routes created yet',
    deleteSuccess: 'Route deleted successfully',
    deleteError: 'An error occurred while deleting the route',
    deleteConfirmTitle: 'Delete route',
    deleteConfirmDesc: 'Are you sure you want to delete route "{name}"? The route will be deactivated.',
    detailsBack: 'Routes', copyId: 'Copy ID', copyIdSuccess: 'ID copied',
    dataRefreshed: 'Data refreshed', notFound: 'Route not found',
    notFoundDesc: 'The requested route could not be found', backToRoutes: 'Back to routes',
    estimatedDistance: 'Estimated distance', estimatedTime: 'Estimated time',
    assignedDrivers: 'Assigned drivers', assignDriver: 'Assign driver',
    editRoute: 'Edit route',
  },
  pricing: {
    listTitle: 'Pricing lists',
    listSubtitle: 'Manage delivery pricing lists and assign to customers',
    createNew: 'Create new list', name: 'Name', defaultPrice: 'Default price',
    deliveryType: 'Delivery type', routesCount: 'Routes count',
    viewDetails: 'View details', delete: 'Delete',
    noLists: 'No pricing lists',
    noListsDesc: 'No pricing lists created yet. Create a new list to get started.',
    deleteSuccess: 'Pricing list deleted successfully', deleteFailed: 'Failed to delete pricing list',
    detailsTitle: 'Pricing list', detailsSubtitle: 'Manage delivery routes and prices',
    editList: 'Edit list', cancelEdit: 'Cancel edit',
    listName: 'List name', defaultDeliveryFee: 'Default price',
    defaultDeliveryType: 'Default delivery type', selectDeliveryType: 'Select delivery type',
    updateSuccess: 'Pricing list updated', updateFailed: 'Failed to update pricing list',
    loadFailed: 'Failed to load pricing list', notSpecified: 'Not specified',
    routesAndRates: 'Routes and rates', addRoute: 'Add route',
    noRoutes: 'No routes',
    noRoutesDesc: 'No routes added yet. The default price will be used for all routes.',
    fromCity: 'From city', toCity: 'To city', price: 'Price',
    from: 'From:', to: 'To:', deleteRoute: 'Delete',
    deleteRateSuccess: 'Rate deleted', deleteRateFailed: 'Failed to delete rate',
    currency: 'SDG',
  },
  carriers: {
    listTitle: 'Carriers', listSubtitle: 'Manage shipping companies',
    addUser: 'Add user', addCarrier: 'Add carrier',
    approve: 'Approve', suspend: 'Suspend', unsuspend: 'Unsuspend',
    noCarriers: 'No carriers',
    noCarriersDescription: 'No carriers found. Start by adding a new carrier.',
    notFound: 'Carrier not found', errorTitle: 'Error',
    backToList: 'Back to carriers list', detailsTitle: 'Carrier details',
    wallet: 'Wallet', tenantSettlements: 'Tenant settlements',
    platformFees: 'Platform fees', editNotification: 'Opening edit dialog...',
  },
  tenants: {
    listTitle: 'Tenants', listSubtitle: 'Manage customers and tenants',
    addTenant: 'Add tenant', subscription: 'Subscription', integration: 'Integration',
    shipments: 'Shipments', enterpriseSubscription: 'Enterprise',
    premiumSubscription: 'Premium', basicSubscription: 'Basic',
    apiIntegration: 'API', webhookIntegration: 'Webhook', manualIntegration: 'Manual',
    noTenants: 'No tenants',
    noTenantsDescription: 'No tenants match the search criteria',
    notFound: 'Tenant not found',
    notFoundDescription: 'The requested tenant could not be found',
    backToList: 'Back to list',
    disableTenant: 'Disable tenant', enableTenant: 'Enable tenant',
    totalShipments: 'Total shipments', newShipments: 'New',
    inDelivery: 'In delivery', completedShipments: 'Completed',
    overview: 'Overview', warehouses: 'Warehouses',
    fulfillmentCenter: 'Fulfillment center', settlements: 'Settlements',
    copiedSuccess: 'Tenant ID copied', loadError: 'Failed to load tenant data',
  },
  users: {
    pageTitle: 'Users', pageDescription: 'Manage user accounts',
    addButton: 'Add user', roleAdmin: 'System admin',
    roleCarrier: 'Carrier', roleDriver: 'Driver',
    roleTenant: 'Tenant', roleCustomer: 'Customer',
    statusActive: 'Active', statusInactive: 'Inactive',
    tableHeaderName: 'Name', tableHeaderEmail: 'Email',
    tableHeaderPhone: 'Phone', tableHeaderRole: 'Role',
    tableHeaderStatus: 'Status', tableHeaderCreatedDate: 'Created date',
    viewDetailsTooltip: 'View details', emptyStateTitle: 'No users',
    emptyStateDescription: 'No users match the search criteria',
    clearFiltersButton: 'Clear filters',
    detailsBack: 'Back to users',
    userNotFound: 'User not found',
    userNotFoundDesc: 'The requested user could not be found',
    accountInfoTitle: 'Account information',
    emailVerificationTitle: 'Email verification',
    emailVerifiedBadge: 'Verified', emailNotVerifiedBadge: 'Not verified',
    emailVerifiedHint: 'This user has confirmed their email address.',
    emailNotVerifiedHint: "This user hasn't confirmed their email yet and cannot sign in.",
    markEmailVerifiedButton: 'Mark email as verified',
    lastLoginLabel: 'Last login', neverLoggedIn: 'Never signed in',
    editButton: 'Edit', editUserTitle: 'Edit user',
    fieldActiveLabel: 'Account active',
    fieldActiveHint: 'The user can sign in and use the account.',
    saveButton: 'Save changes', savingButton: 'Saving...', cancelButton: 'Cancel',
    updateSuccess: 'User updated successfully',
  },
  finance: {
    pageTitle: 'Finance', pageDescription: 'Manage wallets and financial transactions',
    walletServices: 'Services wallet', walletServicesSubtitle: 'Available balance for withdrawal',
    walletCod: 'Cash wallet', walletCodSubtitle: 'Collected cash',
    pendingCod: 'Pending COD', pendingCodSubtitle: 'Awaiting delivery',
    netProfit: 'Net profit', netProfitSubtitle: 'Revenue - expenses',
    tableHeaderTrackingNumber: 'Tracking number', tableHeaderTransactionType: 'Transaction type',
    tableHeaderAmount: 'Amount', tableHeaderStatus: 'Status',
    tableHeaderDate: 'Date', tableHeaderDescription: 'Description',
    transactionTypeServiceFee: 'Service fee',
    transactionTypeCodCollection: 'COD collection',
    transactionTypePayment: 'Payment', transactionTypeRefund: 'Refund',
    statusCompleted: 'Completed', statusPending: 'Pending', statusFailed: 'Failed',
    transactionsTableTitle: 'Financial transactions',
    transactionsTableDescription: 'All financial transactions for shipments',
    noTransactionsMessage: 'No financial transactions',
    noTransactionsDescription: 'No financial transactions recorded yet',
    chartTitle: 'Revenue and COD — Last 30 days',
  },
  reports: {
    pageTitle: 'Reports',
    pageDescription: 'Comprehensive financial and administrative reports',
    dateRangeButton: 'Select period', exportPdfButton: 'Export PDF',
    exportButtonMobile: 'Export',
    shipmentTrendChartTitle: 'Shipments volume — Last 30 days',
    statusDistributionChartTitle: 'Status distribution',
    financialReportsSection: 'Financial reports',
    totalRevenueLabel: 'Total revenue', monthComparisonLabel: 'vs last month',
    totalExpensesLabel: 'Total expenses', netProfitLabel: 'Net profit',
    pendingInvoicesLabel: 'Pending invoices', pendingInvoicesSubtitle: 'pending invoice',
    codCollectedLabel: 'COD collected', codCollectedSubtitle: 'Amounts collected in cash',
    prepaidLabel: 'Prepaid', prepaidSubtitle: 'Online payments',
    managementReportsSection: 'Management reports',
    totalShipmentsLabel: 'Total shipments', totalShipmentsSubtitle: 'In selected period',
    activeTenantLabel: 'Active tenants', activeTenantSubtitle: 'currently active tenant',
    driversLabel: 'Drivers', driversSubtitle: 'driver available',
    pendingOrdersLabel: 'Pending orders', pendingOrdersSubtitle: 'Awaiting delivery',
    completedTodayLabel: 'Completed today', completedTodaySubtitle: 'Delivered today',
    cancelledLabel: 'Cancelled', cancelledSubtitle: 'cancelled shipments',
    performanceReportsSection: 'Performance reports',
    deliveryRateLabel: 'Delivery rate',
    avgDeliveryTimeLabel: 'Average delivery time',
    avgDeliveryTimeSubtitle: 'From pickup to delivery',
    customerSatisfactionLabel: 'Customer satisfaction',
    customerSatisfactionSubtitle: 'out of 5 stars',
    complaintsLabel: 'Complaints',
    complaintsSubtitle: 'complaint in selected period',
    onTimeDeliveryLabel: 'On-time delivery', failureRateLabel: 'Failure rate',
  },
  notFound: {
    errorCode: '404', title: 'Oops! Page not found',
    homeLink: 'Return to home',
  },
  exceptions: {
    title: 'Exception Logs', subtitle: 'Monitor and manage system errors',
    tabs: { logs: 'Logs', incidents: 'Incidents' },
    stats: { total: 'Total Exceptions', last24h: 'Last 24 Hours', topModule: 'Top Module', topCode: 'Top Error Code' },
    filters: {
      title: 'Filters', clear: 'Clear',
      severity: 'Severity', allSeverities: 'All severities',
      source: 'Source', allSources: 'All sources',
      module: 'Module', modulePlaceholder: 'Module name...',
      errorCode: 'Error Code', errorCodePlaceholder: 'e.g. GEN_',
      from: 'From date', to: 'To date',
    },
    columns: {
      time: 'Time', code: 'Code', severity: 'Severity', module: 'Module',
      message: 'Message', origin: 'Origin', source: 'Source',
      lastSeen: 'Last Seen', occurrences: 'Occurrences', firstSeen: 'First Seen',
      status: 'Status', resolved: 'Resolved', open: 'Open',
    },
    detail: {
      message: 'Message', origin: 'Origin', function: 'Function',
      request: 'Request Info', userId: 'User ID', tenantId: 'Tenant ID', ipAddress: 'IP Address',
      details: 'Details', stackTrace: 'Stack Trace',
      requestBody: 'Request Body', requestQuery: 'Query Params', requestHeaders: 'Request Headers',
      sqlHelper: 'SQL Query', sqlCopied: 'SQL query copied',
      correlationIdCopied: 'Correlation ID copied', recentLogs: 'Recent Logs',
    },
    resolve: {
      title: 'Mark as Resolved', notePlaceholder: 'Resolution note (optional)...',
      button: 'Mark Resolved', resolving: 'Resolving...', success: 'Incident marked as resolved',
    },
    emptyLogs: 'No logs found', emptyLogsDesc: 'No exception logs match the selected filters',
    emptyIncidents: 'No incidents found', emptyIncidentsDesc: 'No incidents match the selected filters',
  },
  outstandingFees: {
    pageTitle: 'Outstanding fees',
    pageSubtitleCarrier: 'Unpaid tenant delivery fees — mark them paid once you confirm the bank transfer',
    pageSubtitleTenant: 'Delivery fees you owe to your carrier',
    refresh: 'Refresh',
    totalOwed: 'Total owed',
    shipmentsCount: 'Shipments',
    tenantsCount: 'Tenants',
    shipmentsLabel: 'shipments',
    markAllPaid: 'Mark all paid',
    markPaid: 'Mark paid',
    markPaidSuccess: 'Fees marked as paid',
    markPaidError: 'Could not update, please try again',
    loadError: 'Could not load outstanding fees',
    emptyTitle: 'No outstanding fees',
    emptyDescription: 'No shipments with unpaid delivery fees right now',
  },
  support: {
    pageTitle: 'Support',
    pageSubtitle: 'Contact the QuBox support team or browse the FAQ',
    contactTitle: 'Contact us',
    contactDescription: 'Our support team is here to help',
    whatsappLabel: 'WhatsApp',
    whatsappAction: 'Chat on WhatsApp',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    hoursLabel: 'Working hours',
    hoursValue: 'Sun - Thu, 9 AM - 5 PM',
    formTitle: 'Send us a message',
    formDescription: 'We will reply to your registered email address',
    categoryLabel: 'Request type',
    categoryPlaceholder: 'Select a request type',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'A short title for your request',
    relatedRefLabel: 'Related number (optional)',
    relatedRefPlaceholder: 'A related tracking or order number',
    messageLabel: 'Message',
    messagePlaceholder: 'Describe your issue or question in detail...',
    submitButton: 'Send',
    submitting: 'Sending...',
    successTitle: 'Message received',
    successMessage: 'Thanks for reaching out. Our support team will get back to you shortly.',
    sendAnother: 'Send another message',
    errorMessage: 'Could not send your message. Please try again.',
    validationError: 'Please fill in the request type, subject and message',
    faqTitle: 'Frequently asked questions',
    tenantCategories: [
      'Shipments & tracking',
      'COD & payouts',
      'Account & login',
      'App problem',
      'Other',
    ],
    carrierCategories: [
      'Account & activation',
      'Wallet & billing',
      'Drivers & operations',
      'Settlements & finance',
      'App problem',
      'Feature request',
      'Other',
    ],
    tenantFaq: [
      { q: 'How do I create a shipment?', a: 'From the Shipments list click "Add new shipment", enter the recipient and package details, pick a service type, and confirm.' },
      { q: 'How do I track a shipment?', a: "Open the Shipments list — each shipment's status updates live. You can also share the public tracking link with your customer." },
      { q: 'When do I receive my COD payouts?', a: 'Cash collected on delivery is settled to you by your carrier on their settlement cycle — see the Settlements page for details.' },
      { q: 'How do I print a shipping label or barcode?', a: "From a shipment's details page use \"Print\", or use \"Barcode → Print\" to print a whole batch." },
      { q: 'Why was my shipment returned?', a: 'A shipment is returned after failed delivery attempts or recipient refusal — open its timeline to see the reason.' },
      { q: 'How do I add a pickup warehouse?', a: 'Go to Settings → Warehouses and add your pickup address; it then becomes selectable when creating shipments.' },
    ],
    carrierFaq: [
      { q: 'How do I add drivers?', a: 'From the Drivers list click "Add driver", then assign shipments or routes to them.' },
      { q: 'What is the wallet used for?', a: 'Your wallet covers QuBox platform fees — keep it topped up so your service is not interrupted.' },
      { q: 'How do settlements work?', a: 'Tenant settlements pay merchants their COD, driver COD settlements collect cash from drivers, and driver pay settlements pay driver wages and commission.' },
      { q: 'How do I set up routes, zones and pricing?', a: 'Under Settings, define delivery zones, routes and pricing lists, then assign a pricing list to each tenant.' },
      { q: 'How do I onboard a merchant (tenant)?', a: 'Approve their registration or add them from the Tenants list, then assign a pricing list so they can ship.' },
      { q: 'How do manifests and fulfillment centers work?', a: 'Manifests group shipments into pickup, transfer or delivery runs, and fulfillment centers receive, sort and dispatch them.' },
    ],
  },
};
